function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useCallback, useMemo, useState } from 'react';
import classNames from 'classnames';
import clamp from 'lodash.clamp';
import { vsAdd, vsTrash } from '@deephaven/icons';
import { RangeUtils } from '@deephaven/utils';
import Button from "./Button.js";
import ItemList from "./ItemList.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Display a list of items with an input for adding new items, and Add/Delete buttons
function EditableItemList(props) {
  var _props$isInvalid = props.isInvalid,
    isInvalid = _props$isInvalid === void 0 ? false : _props$isInvalid,
    items = props.items,
    _props$onAdd = props.onAdd,
    onAdd = _props$onAdd === void 0 ? () => undefined : _props$onAdd,
    _props$onDelete = props.onDelete,
    onDelete = _props$onDelete === void 0 ? () => undefined : _props$onDelete,
    _props$validate = props.validate,
    validate = _props$validate === void 0 ? () => null : _props$validate;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    inputError = _useState2[0],
    setInputError = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedRanges = _useState4[0],
    setSelectedRanges = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    value = _useState6[0],
    setValue = _useState6[1];
  var handleSelectionChange = useCallback(ranges => {
    setSelectedRanges(ranges);
  }, []);
  var handleDelete = useCallback(() => {
    onDelete(RangeUtils.getItemsInRanges(items, selectedRanges));
    setSelectedRanges([]);
  }, [items, selectedRanges, onDelete]);
  var handleAdd = useCallback(() => {
    if (value === '') {
      return;
    }
    var validationError = validate(value);
    if (validationError == null) {
      onAdd(value);
      setValue('');
    } else {
      setInputError(validationError);
    }
  }, [value, onAdd, validate]);
  var handleInputChange = useCallback(event => {
    var inputValue = event.target.value;
    setValue(inputValue);
    setInputError(inputValue === '' ? null : validate(inputValue));
  }, [validate]);
  var handleInputFocus = useCallback(() => {
    setSelectedRanges([]);
  }, []);
  var handleInputKeyDown = useCallback(event => {
    if (event.key === 'Enter') {
      handleAdd();
    }
  }, [handleAdd]);
  var containerHeight = useMemo(() => 14 + clamp(items.length, 1, 6) * ItemList.DEFAULT_ROW_HEIGHT, [items.length]);
  return /*#__PURE__*/_jsxs("div", {
    className: classNames('editable-item-list-container', {
      'is-invalid': isInvalid
    }),
    children: [/*#__PURE__*/_jsx("div", {
      style: {
        height: containerHeight
      },
      children: /*#__PURE__*/_jsx(ItemList, {
        itemCount: items.length,
        items: items.map((item, index) => ({
          value: item,
          isSelected: RangeUtils.isSelected(selectedRanges, index)
        })),
        offset: 0,
        selectedRanges: selectedRanges,
        onSelectionChange: handleSelectionChange,
        isMultiSelect: true
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: "d-flex flex-row pt-2",
      children: [/*#__PURE__*/_jsx("div", {
        className: "d-flex flex-grow-1",
        children: /*#__PURE__*/_jsx("input", {
          className: classNames('form-control', {
            'is-invalid': inputError != null
          }),
          placeholder: "Enter value",
          type: "text",
          value: value,
          onChange: handleInputChange,
          onFocus: handleInputFocus,
          onKeyDown: handleInputKeyDown
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: "d-flex align-items-start mt-1 ml-2",
        children: [/*#__PURE__*/_jsx(Button, {
          kind: "ghost",
          onClick: handleAdd,
          disabled: inputError != null || value === '',
          icon: vsAdd,
          tooltip: "Add new item",
          "data-testid": "add-item-button"
        }), /*#__PURE__*/_jsx(Button, {
          kind: "ghost",
          onClick: handleDelete,
          disabled: selectedRanges.length === 0,
          icon: vsTrash,
          tooltip: "Delete selected items",
          "data-testid": "delete-item-button"
        })]
      })]
    })]
  });
}
export default EditableItemList;
//# sourceMappingURL=EditableItemList.js.map